import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DeclineReason } from 'ng2-app/models/dto/decline-reason.model';

@Component({
  selector: 'app-decline-info-dialog',
  templateUrl: './decline-info-dialog.component.html',
  styleUrls: ['./decline-info-dialog.component.scss'],
  standalone: false
})
export class DeclineInfoDialogComponent implements OnInit  {
  badges: string[];
  comments: string[];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
  ) { }

  ngOnInit(): void {
    const declineReasons = this.data.declineReasons as DeclineReason[] || [];
    this.badges = declineReasons
      .filter((item) => item.reason.toLowerCase() !== 'other')
      .map((item) => item.reason);

    this.comments = declineReasons
      .filter((item) => Boolean(item.comment))
      .map(item => item.comment || '');
  }
}
